const e = {
  page404: {
    title: "Zřejmě jste se ztratili",
    message: "Ztratili jste se?",
    action_btn: "Zpět na úvod"
  },
  address: {
    title: "Address",
    type: {
      personal: "Soukromá osoba",
      company: "Firma"
    },
    organisation: {
      label: "Název firmy"
    },
    name: {
      first_name: "Jméno",
      last_name: "Příjmení",
      label: "Jméno"
    },
    contact_person: {
      first_name: "Jméno",
      last_name: "Příjmení",
      label: "Kontaktní osoba"
    },
    street: {
      label: "Ulice a číslo",
      address1: "Address 1",
      address2: "Address 2"
    },
    city: {
      label: "Město"
    },
    postal_code: {
      label: "PSČ"
    },
    country_code: {
      label: "Země"
    },
    company_data: {
      title: "Firemní údaje"
    },
    company_id: {
      label: "IČO"
    },
    tax_id: {
      label: "DIČ"
    },
    vat_id: {
      label: "IČ DPH"
    }
  },
  empty_state: {
    title: "Nothing to show here..."
  },
  profile: {
    emails: {
      label: "Email (můžete zadat více emailů)"
    },
    email: {
      label: "Email"
    },
    phone: {
      label: "Telefon",
      short: "Phone"
    }
  },
  validation: {
    country_required: "Vyplňte zemi",
    company_id: {
      not_valid: "Neplatné IČO"
    },
    tax_id: {
      not_valid: "Neplatné DIČ"
    },
    vat_id: {
      not_valid: "Neplatné IČ DPH"
    }
  },
  general: {
    back: "Zpět",
    cancel: "Zrušit",
    close: "Zavřít",
    remove: "Odstranit",
    optional: "nepovinné",
    period: {
      months: "{period, plural, one {# měsíc} few {# měsíce} other {# měsíců}}",
      years: "{period, plural, one {# rok} few {# roky} other {# roků}}",
      explicit: "Období",
      short: {
        months: "{period, plural, one {# měsíc} few {# měsíce} other {# měsíců}}",
        years: "{period, plural, one {rok} few {#roky} other {#roků}}"
      },
      next: {
        months: "{period, plural, one {příští měsíc} few {příští # měsíce} other {příštích # měsíců}}",
        years: "{period, plural, one {příští rok} few {příští # roky} other {příštích # roků}}",
        short: {
          months: "{period, plural, one {příští měs} few {příští #měs} other {příštích #měs}}",
          years: "{period, plural, one {příští rok} few {příští #roky} other {příštích #roků}}"
        }
      },
      per: {
        months: "{period, plural, one {měsíčně} few {na # měsíce} other {na # měsíců}}",
        years: "{period, plural, one {ročně} few {na # roky} other {na # roků}}",
        short: {
          months: "{period, plural, one {/měs} other {/#měs} }",
          years: "{period, plural, one {/rok} few {/#roky} other {/#roků}}"
        }
      }
    },
    or: "nebo",
    recommended: "doporučeno",
    settings: "Nastavení",
    edit: "Upravit",
    save: "Uložit",
    save_changes: "Uložit",
    reset_form: "vymazat formulář",
    not_available: "Nedostupné",
    unknown_error: "Neznámá chyba",
    unknown_error_id: "Neznámá chyba ({id})",
    something_went_wrong: "Omlouváme se za neočekávaný výsledek. Něco se pokazilo.",
    link: "odkaz",
    buy: "Koupit"
  },
  capslock_hint: {
    line1: "Caps Lock",
    line2: "je zapnutý"
  },
  ws_array_input: {
    some_filtered: "Tento řetězec není možné zpracovat."
  },
  ws_places_input: {
    no_results: "Hledané místo nebylo nalezeno. Zkuste méně specifickou adresu"
  },
  ws_uploader: {
    validation: {
      file_type: "Nesprávný typ souboru.",
      file_size: "Velikost souboru překračuje limit ({limit})"
    },
    status: {
      label: "Stav",
      value: {
        uploaded: "nahrané",
        uploading: "Nahrávám",
        failed: "selhání",
        idle: "idle"
      }
    },
    action: {
      title: "Nahrané faktury",
      text1: "Přesuňte soubor nebo",
      link: "vyberte",
      text2: ".",
      abort_tooltip: "Zrušit nahrávání"
    },
    remove_btn: "Odstranit"
  },
  ws_table: {
    filter: {
      fulltext_title: "Fulltextové vyhledávání",
      data_title: "Vyhledávání",
      clear_filters: "Vymazat všechny filtry",
      from: "Od",
      to: "Do"
    },
    label: {
      bulk_actions: "Hromadná akce",
      cancel_selection: "Zrušit výběr",
      item_selected: "vybrané položky",
      selected: "Vybraný",
      filterby: "Filtrovat podle",
      records_per_page: "Položek na stránce:",
      select_all: "Vybrat vše"
    }
  },
  ws_password_strength: {
    rule1: "Minimálně 8 znaků",
    rule2: "Minimálně 1 velké a 1 malé písmeno",
    rule3: "Minimálně 1 číslo",
    rule4: "Minimálně  1 speciální znak"
  },
  ws_password_confirmation_input: {
    passwords_do_not_match: "Hesla se neshodují!"
  },
  ws_two_factor_authentication_input: {
    on_cooldown_one: "You can resend the code again in {{count}} second.",
    on_cooldown_few: "You can resend the code again in {{count}} seconds.",
    on_cooldown_other: "You can resend the code again in {{count}} seconds.",
    resend_code: "Resend code",
    code_being_sent: "Sending 2FA code...",
    code_sent_successfully: "2FA code sent successfully",
    error_sending_code: "Error sending 2FA code",
    invalid_code_pasted: "Vložili jste neplatný kód 2FA. Zadejte prosím platný kód 2FA."
  },
  generate_random: "Generuj náhodné",
  copy: {
    copy: "Kopírovat",
    copied: "Zkopírováno",
    saved_in_clipboard: "Zkopírováno"
  },
  out_modal: {
    title: "Váš prohlížeč není aktuální",
    text: "Aktualizujte si prosím váš prohlížeč nebo zkuste nainstalovat jiný.",
    delimiter_text: "Můžeme pomoci"
  },
  buttons: {
    ok_thanks: "Ok, Thanks"
  },
  payment_cards: {
    ending_with: "Ending with",
    active: "Active"
  },
  ws_sub_items_price_summary: {
    current_price: "Cena za službu (aktuální fakturační období)",
    due_now: "Splatné ihned",
    next_period_subtraction_warning: "* Cena bude odečtena v následujícím fakturačním období",
    next_price: "Cena za službu (následující fakturační období)"
  },
  dialog_footer: {
    cannot_submit_empty_form: "It is not possible to submit an empty form."
  },
  price_badge: {
    including_vat: "(s DPH)",
    excluding_vat: "(bez DPH)"
  },
  login_pages: {
    footer: {
      help: "Pomoc",
      terms: "Podmínky",
      privacy: "Soukromí"
    },
    help: {
      title: "Potřebujete poradit?",
      text: "Vždy můžete navštívit naši <a href='{kb_url}' target='_blank'>znalostní bázi </a> nebo kontaktovat naši <a href='{support_url}' target='_blank'>zákaznickou podporu</a>."
    }
  },
  message_service: {
    error: {
      axios: {
        title: "Network Error",
        text: "Unable to connect"
      },
      unexpected: {
        title: "Error",
        text: "Unexpected error"
      }
    }
  }
}, o = {
  wsk: e
};
export {
  o as default,
  e as wsk
};
//# sourceMappingURL=wsk.cs-CZ-bdddeac7.js.map
